import { useMutation, useQuery } from "@apollo/client";
import { Box, Typography, useTheme } from "@mui/material";
import * as Yup from "yup";
import { useEffect, useMemo, useState } from "react";

import { useParams } from "react-router-dom";
import {
  CreateIngestionServiceDocument,
  GetCurrentUserInfoDocument,
  GetIngestionServicesDocument,
  GetProjectManagersAndOwnersDocument,
  GetWorkspaceInfoDocument,
  IngestionServiceProvider,
} from "../../../generated";
import { Button } from "../../Button/Button";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { Search } from "../Transformation/Search";
import { Fields } from "./Fields";
import RightSidePanel from "../../RightSidePanel";
import {
  PanelHolder,
  PanelContent,
  PanelTopContent,
  PanelContentHead,
  HeadSmallTitle,
  HeadTitle,
  FormCenter,
  FooterBtnHolder,
} from "../style";
import { size } from "lodash";

const options = [
  {
    title: IngestionServiceProvider.AirbyteOss.replaceAll("_", " "),
    value: IngestionServiceProvider.AirbyteOss,
    method: "On Platform",
    owner: "Brighthive",
    description: "Description goes here",
  },
  {
    title: IngestionServiceProvider.AirbyteCloud.replaceAll("_", " "),
    value: IngestionServiceProvider.AirbyteCloud,
    method: "On Platform",
    owner: "Brighthive",
    description: "Description goes here",
  },
];

export const AddIngestions = () => {
  const [open, setOpen] = useState(false);
  const [disabledAddIngestion, setDisabledAddIngestion] = useState(true);

  const close = () => {
    setOpen(false);
  };
  const { workspaceId } = useParams();
  const { palette } = useTheme();

  const { data: ingestionServices, loading: ingestionLoading } = useQuery(
    GetIngestionServicesDocument,
    {
      variables: {
        input: {
          workspaceId: workspaceId || "",
        },
      },
    }
  );

  const { airbyteWorkspaceId, datapiaryServiceId } = useMemo(() => {
    const service =
      ingestionServices?.workspace?.services?.ingestionServices[0];
    if (size(service) < 1) {
      setDisabledAddIngestion(false);
    } else {
      setDisabledAddIngestion(true);
    }
    return {
      airbyteWorkspaceId: service?.airbyteWorkspaceId || "",
      datapiaryServiceId: service?.datapiaryServiceId || "",
    };
  }, [ingestionServices]);

  const [create, { loading }] = useMutation(CreateIngestionServiceDocument, {
    refetchQueries: [GetIngestionServicesDocument],
  });

  const { data } = useQuery(GetCurrentUserInfoDocument);

  const { data: workspaceInfo, loading: workspaceInfoLoading } = useQuery(
    GetWorkspaceInfoDocument,
    {
      variables: {
        input: {
          workspaceId: workspaceId || "",
        },
      },
    }
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          alignItems: "flex-end",
        }}
      >
        <Button
          disabled={disabledAddIngestion}
          onClick={() => setOpen(true)}
          variant="contained"
        >
          Add Ingestion
        </Button>
        {disabledAddIngestion && (
          <Typography variant="body3">
            Currently we only support one ingestion
          </Typography>
        )}
      </Box>
      {open && (
        <RightSidePanel isOpen={open} onToggle={close}>
          <PanelHolder>
            <Formik
              validationSchema={Yup.object().shape({
                name: Yup.string().required("Name is required"),
                description: Yup.string(),
                api_url: Yup.string()
                  .url("Must be a valid URL")
                  .required("API URL is required"),
                provider: Yup.string().required("Provider Name is required"),
                api_key: Yup.string(),
                airbyteClientId: Yup.string().required("Client ID is required"),
                airbyteClientSecret: Yup.string().required(
                  "Client Secret is required"
                ),
                airbyteOrganizationId: Yup.string().required(
                  "Organization ID is required"
                ),
              })}
              initialValues={{
                name: "",
                description: "",
                transformationMethod: "managed-services",
                provider: null as any,
                api_url: "",
                api_key: "",
                airbyteClientId: "",
                airbyteClientSecret: "",
                airbyteOrganizationId: "",
              }}
              onSubmit={(values) => {
                const { transformationMethod, ...restValues } = values;

                create({
                  variables: {
                    input: {
                      workspaceId: workspaceId || "",
                      managerId: data?.currentUser.id || "",
                      provider: values.provider,
                      ownerId: workspaceInfo?.workspace?.owner?.id || "",
                      datapiaryServiceId: datapiaryServiceId || "12345",
                      apiUrl: values.api_url,
                      name: values.name,
                      description: values.description,
                      airbyteWorkspaceId: airbyteWorkspaceId,
                      apiKey: values.api_key,
                      status: "CONNECTED",
                      airbyteClientId: values.airbyteClientId,
                      airbyteClientSecret: values.airbyteClientSecret,
                      airbyteOrganizationId: values.airbyteOrganizationId,

                      // configurations: JSON.stringify(configurations),
                      // ...restValues,
                    },
                  },
                }).then((res) => {
                  if (res.data?.createIngestionService.success) {
                    toast.success(
                      "Service created " +
                        res.data?.createIngestionService.ingestionServiceId
                    );
                  } else {
                    toast.error("Failed to create service");
                  }
                  close();
                });
              }}
              validateOnBlur={true}
              validateOnChange={true}
            >
              {({
                handleChange,
                errors,
                touched,
                handleSubmit,
                values,
                setFieldValue,
                handleBlur,
                isValid,
                resetForm,
              }) => (
                <form onSubmit={handleSubmit}>
                  <PanelContent>
                    <PanelTopContent>
                      <PanelContentHead>
                        <HeadSmallTitle>Ingestion</HeadSmallTitle>
                        <HeadTitle>New Ingestion</HeadTitle>
                      </PanelContentHead>
                      {/*  <SubHeading>Connection Service Type</SubHeading>
                      <RadioHolder>
                        <FormControl>
                          <RadioGroup
                            defaultValue="platform"
                            name="transformationMethod"
                            value={values.transformationMethod}
                            onChange={handleChange}
                          >
                            <FormControlLabel
                              value="managed-services"
                              control={<Radio />}
                              className="formlist"
                              label={
                                <>
                                  <LabelTitle>Managed Service</LabelTitle>
                                  <LableDes>
                                    Securely transform data using engines
                                    private to this workspace. This means your
                                    data never leaves the workspace.
                                  </LableDes>
                                </>
                              }
                            />

                            <FormControlLabel
                            value={"Customer-hosted"}
                            control={<Radio />}
                            label={
                              <>
                                <Typography
                                  variant="body1"
                                  mb={2}
                                  fontSize="1rem"
                                  lineHeight="1"
                                  fontWeight={400}
                                  className="label-title"
                                  color={palette.common.black}
                                >
                                  Customer-hosted
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize="0.875rem"
                                  lineHeight="1.2"
                                  fontWeight={400}
                                  color={palette.gray.darkest}
                                >
                                  Transform data off-platform using external
                                  engines managed by an approved workspace
                                  organization.
                                </Typography>
                              </>
                            }
                          />
                          <FormControlLabel
                            value={"custom-link"}
                            control={<Radio />}
                            label={
                              <>
                                <Typography
                                  variant="body1"
                                  mb={2}
                                  fontSize="1rem"
                                  lineHeight="1"
                                  fontWeight={400}
                                  className="label-title"
                                  color={palette.common.black}
                                >
                                  Custom link
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize="0.875rem"
                                  lineHeight="1.2"
                                  fontWeight={400}
                                  color={palette.gray.darkest}
                                >
                                  Link to the service for reference, but
                                  brightbot can’t interact with it
                                </Typography>
                              </>
                            }
                          />
                          </RadioGroup>
                        </FormControl>
                      </RadioHolder> */}
                      <FormCenter>
                        {true && (
                          <>
                            <Search
                              options={options}
                              setFieldValue={setFieldValue}
                              values={values}
                              resetForm={resetForm}
                              disabled={
                                ingestionLoading || workspaceInfoLoading
                              }
                            />

                            {values.provider && (
                              <Fields
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                values={values}
                                errors={errors}
                                touched={touched}
                              />
                            )}
                          </>
                        )}
                      </FormCenter>
                    </PanelTopContent>
                    <FooterBtnHolder>
                      <Button onClick={() => setOpen(false)} variant="outlined">
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={loading || !isValid || !values.provider}
                        type="submit"
                      >
                        Add Service
                      </Button>
                    </FooterBtnHolder>
                  </PanelContent>
                </form>
              )}
            </Formik>
          </PanelHolder>
        </RightSidePanel>
      )}
    </>
  );
};
